/* HV-CUSTOM: search-form.js komplett auf Live-Stand (Security-Haertung: URL-Validierung,
   sichere DOM-Erzeugung/Query-Sanitizing statt Base-innerHTML). Funktionsumfang
   identisch zur 18.2.2-Base. Siehe docs/development/CUSTOMIZATIONS.md (HV-JS-SEC) */
/*! Copyright (c) Safe As Milk. All rights reserved. */
class SearchForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector("form");
    }
    connectedCallback() {
        if (this.hasAttribute("add-recent-search-on-load")) this.addFormStateToRecentSearches();
    }
    /**
     * Validates if a URL is safe (same-origin only)
     * @param {string} url - URL to validate
     * @returns {boolean} - True if URL is safe
     */
    static isValidUrl(url) {
        try {
            const parsed = new URL(url, window.location.origin);
            // Only allow same-origin URLs
            return parsed.origin === window.location.origin;
        } catch {
            return false;
        }
    }
    
    static addRecentSearch(query, uri) {
        // Validate inputs
        if (!query || typeof query !== 'string' || !uri || typeof uri !== 'string') return;
        
        // Validate URL is safe
        if (!SearchForm.isValidUrl(uri)) {
            // Silently reject invalid URLs
            return;
        }
        
        // Sanitize query (remove potential XSS)
        const sanitizedQuery = query.trim().slice(0, 100); // Limit length
        if (!sanitizedQuery) return;
        
        const getUniqueListBy = (arr, key) => [ ...new Map(arr.map((item => [ item[key], item ]))).values() ];
        let recentSearches = [ {
            query: sanitizedQuery,
            uri: uri
        } ];
        
        const recentSearchesStoredString = localStorage.getItem("recentSearches");
        if (recentSearchesStoredString) {
            try {
                const recentSearchesStored = JSON.parse(recentSearchesStoredString);
                // Validate data structure
                if (!Array.isArray(recentSearchesStored)) {
                    throw new Error("Invalid data structure");
                }
                
                // Filter out invalid items
                const validStoredSearches = recentSearchesStored.filter(item => {
                    if (!item || typeof item !== 'object') return false;
                    if (!item.query || typeof item.query !== 'string') return false;
                    if (!item.uri || typeof item.uri !== 'string') return false;
                    return SearchForm.isValidUrl(item.uri);
                });
                
                const combinedSearches = [ ...validStoredSearches, ...recentSearches ];
                recentSearches = getUniqueListBy(combinedSearches.reverse(), "query").reverse();
                if (recentSearches.length > 5) {
                    recentSearches = recentSearches.slice(-5);
                }
            } catch (error) {
                // If parsing fails, start fresh
                console.error("Error parsing recent searches:", error);
                localStorage.removeItem("recentSearches");
            }
        }
        
        try {
            localStorage.setItem("recentSearches", JSON.stringify(recentSearches));
            document.querySelectorAll("recent-searches").forEach((el => el.update()));
        } catch (error) {
            console.error("Error saving recent searches:", error);
        }
    }
    addFormStateToRecentSearches() {
        if (!this.form) return;
        const form = new FormData(this.form);
        const search = new URLSearchParams(form);
        const formAction = new URL(`${window.location.origin}${this.form.getAttribute("action")}`);
        const formActionOrigin = window.location.origin;
        const formActionPath = formAction.pathname;
        const formActionSearch = formAction.searchParams;
        const combinedSearch = new URLSearchParams({
            ...Object.fromEntries(formActionSearch),
            ...Object.fromEntries(search)
        });
        SearchForm.addRecentSearch(form.get("q"), `${formActionOrigin}${formActionPath}?${combinedSearch.toString()}`);
    }
}

customElements.define("search-form", SearchForm);
//# sourceMappingURL=search-form.js.map
